import { aiAnalysisLatestUpdateDate } from '@aibees/elephant/components/person-ai-analysis-info/utils';
import { UnlockAiAnalysis } from '@aibees/elephant/components/unlock-ai-analysis';
import { classnames } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { AiPersonalityHeaderProps as Props } from './types';

export const AiPersonalityHeader = memo(
  ({ className, isPopover, unlocked, data }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('AiPersonalityHeader', className)}
        sx={SX.root}
      >
        <Stack gap={1}>
          <Typography
            variant={isPopover ? 'body3' : 'body2'}
            fontWeight={600}
            color="grey.700"
          >
            AI Personality
          </Typography>
          {unlocked && !!isPopover && (
            <Typography variant="body4" color="grey.600">
              {`Last Update ${aiAnalysisLatestUpdateDate(data)}`}
            </Typography>
          )}
        </Stack>
        {!!isPopover && <UnlockAiAnalysis />}
      </Styled.Wrapper>
    );
  }
);

AiPersonalityHeader.displayName = 'AiPersonalityHeader';
